import { createFileRoute } from "@tanstack/react-router";
import AdminGiftCardsPage, { isGiftStatus, type GiftStatus } from "@/admin/pages/gift-cards";

/** The ledger search lives in the URL so a refresh, Back or a pasted link reproduces it. */
export type AdminGiftCardsSearch = {
  q?: string;
  status?: GiftStatus;
};

export const Route = createFileRoute("/admin/gift-cards/")({
  component: AdminGiftCardsPage,
  validateSearch: (search: Record<string, unknown>): AdminGiftCardsSearch => ({
    q: (typeof search.q === "string" && search.q.trim()) || undefined,
    status: isGiftStatus(search.status) ? search.status : undefined,
  }),
});
